module.exports = __webpack_public_path__ + "img/trig-textbook-inactive.51d33ed3.png";